module.exports = __webpack_public_path__ + "img/noyijian.b5cd09d0.png";